// eslint-disable-next-line import/prefer-default-export
export const POLICY_FORM_SECTIONS = [
  {
    title: "Let's set the foundation",
    description: "Give this leave policy a name and select the type of leave it applies to.",
    fields: [
      {
        type: "text",
        name: "policyName",
        label: "Policy name",
        apiKey: "leaveType",
        isDisabled: true,
      },
      {
        type: "select",
        name: "leaveType",
        label: "What kind of leave is this?",
        apiKey: "leaveStart",
        options: [
          { value: "yearly", label: "Yearly" },
          { value: "monthly", label: "Monthly" },
          { value: "quarterly", label: "Quarterly" },
        ],
        isDisabled: true,
      },
      {
        type: "input-with-suffix",
        name: "daysCount",
        label: "How many days off can someone take under this policy?",
        apiKey: "leaveQuota",
        suffix: "day(s)",
        isDisabled: true,
      },
    ],
  },
  {
    title: "Who can take this leave?",
    description: "Set the number of leave days, when employees become eligible, and who this policy applies to.",
    fields: [
      {
        type: "select",
        name: "eligibilityType",
        label: "When do employee become eligible for this leave?",
        apiKeys: {
          condition: "tenure",
          value: "eligibilityPeriodDays",
          unit: "eligibilityUnit",
        },
        options: [
          { value: "is equal to", label: "is equal to" },
          { value: "is greater than", label: "is greater than" },
          { value: "is less than", label: "is less than" },
          { value: "no tenure requirement", label: "No tenure requirement" },
        ],
        customComponent: "eligibility", // This will be handled separately
        isDisabled: true,
      },
      {
        type: "select",
        name: "gender",
        label: "Which gender does this policy apply to?",
        apiKey: "gender",
        options: [
          { value: "all", label: "All" },
          { value: "male", label: "Male" },
          { value: "female", label: "Female" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "paidStatus",
        label: "Is this leave paid or unpaid?",
        apiKey: "unpaidAllowed", // Inverted logic: unpaidAllowed = false means paidStatus = "paid"
        options: [
          { value: "paid", label: "Paid" },
          { value: "unpaid", label: "Unpaid" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "unpaidContinuation",
        label: "Can employees continue with unpaid leave after using all paid days?",
        apiKey: "unpaidAllowed",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
    ],
  },
  {
    title: "Is this leave accrued over time?",
    description: "If leave is accrued over time, configure how it accrues and when employees start earning it.",
    fields: [
      {
        type: "select",
        name: "accrueOverTime",
        label: "Do employees accrue leave over time?",
        apiKey: "monthlyAccrualApplicable",
        options: [
          { value: "no", label: "No" },
          { value: "yes", label: "Yes" },
        ],
        isDisabled: true,
      },
      {
        type: "select",
        name: "accrualSchedule",
        label: "How should the leave accrual be scheduled?",
        apiKey: "accrualSchedule",
        options: [
          { value: "monthly", label: "Monthly" },
          { value: "quarterly", label: "Quarterly" },
          { value: "yearly", label: "Yearly" },
        ],
        isDisabled: true,
        showIf: (values) => values.accrueOverTime === "yes",
      },
      {
        type: "select",
        name: "accrualBegin",
        label: "When should leave accrual begin?",
        apiKey: "leaveStart",
        options: [
          { value: "joining date", label: "Joining date" },
          { value: "after probation", label: "After probation" },
          { value: "after a year", label: "After a year" },
        ],
        isDisabled: true,
        showIf: (values) => values.accrueOverTime === "yes",
      },
      {
        name: "accrualRules",
        customComponent: "accrualRules",
        label: "Specify how much leave is added on each accrual",
        labels: {
          amount: "Accrue",
          timing: "per month at",
        },
        apiKeys: {
          amount: "monthlyAccrualQuota",
          unit: "monthlyAccrualUnit",
          timing: "monthlyAccrualTiming",
        },
        isDisabled: true,
        showIf: (values) => values.accrueOverTime === "yes",
      },
      {
        type: "radio",
        name: "accrualBeginTiming",
        label: "When should accrual begin?",
        apiKey: "accrualBeginTiming",
        options: [
          { value: "after joining", label: "After joining" },
          { value: "after probation", label: "After probation" },
        ],
        isDisabled: true,
        showIf: (values) => values.accrueOverTime === "yes",
      },
      {
        type: "radio",
        name: "continueAccrualAfterFirstYear",
        label: "Does this accrual method continue after the first year?",
        apiKey: "limitAccrualToFirstYear",
        options: [
          { value: "yes", label: "Yes, keep it going" },
          { value: "no", label: "No, switch to a yearly leave entitlement after year one" },
        ],
        isDisabled: true,
        showIf: (values) => values.accrueOverTime === "yes",
      },
    ],
  },
  {
    title: "Configure usage rules",
    description: "Setup how employees can use this leave during their time at the company.",
    fields: [
      {
        type: "radio",
        name: "applyInAdvance",
        label: "Can employees apply for this leave in advance?",
        apiKey: "advanceAllowed",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "applyHalfDay",
        label: "Can employees apply for a half day under this policy?",
        apiKey: "halfLeaveAllowed",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "allowedDuringProbation",
        label: "Is this leave allowed during probation?",
        apiKey: "allowedInProbation",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "allowedDuringNotice",
        label: "Is this leave allowed during notice period?",
        apiKey: "allowedInNoticePeriod",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "input-with-suffix",
        name: "probationQuota",
        label: "What's the maximum number of days allowed during probation?",
        apiKey: "probationQuota",
        suffix: "day(s)",
        isDisabled: true,
      },
      {
        type: "radio",
        name: "countWeekends",
        label: "Should weekends be counted as leave days?",
        apiKey: "includeWeekends",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "allowWeekendSelection",
        label: "Allow selecting weekends on the leave calendar?",
        apiKey: "allowWeekendSelection",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "sandwichSeparateRequests",
        label: "Include Sat/Sun between separate Fri and Mon leave requests (requires weekends counted)?",
        apiKey: "sandwichSeparateRequests",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "radio",
        name: "countPublicHolidays",
        label: "Should public holidays be counted as leave days?",
        apiKey: "includeHolidays",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
    ],
  },
  {
    title: "Setup encashment and carry forward rules",
    description: "Choose what happens to unused leave — whether it can be carried forward, encashed, or set to expire.",
    fields: [
      {
        type: "radio",
        name: "canEncash",
        label: "Can employees encash unused leave?",
        apiKey: "encashmentApplies",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        name: "encashmentRules",
        customComponent: "encashment",
        labels: {
          amount: "How much can they encash?",
          rate: "Rate",
          rateType: "Multiplier of",
        },
        apiKeys: {
          amount: "maxEncashmentLimit",
          rate: "encashmentRate",
          rateType: "encashmentRateType",
        },
        isDisabled: true,
      },
      {
        type: "radio",
        name: "canCarryForward",
        label: "Can employees carry forward unused leave to the next year?",
        apiKey: "carryForwardApplies",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        name: "carryForwardRules",
        customComponent: "carryForward",
        labels: {
          limit: "Maximum carry forward limit",
          expiry: "Carry forward leaves expire after",
        },
        apiKeys: {
          limit: "maxCarryForwardLimit",
          expiry: "carryForwardExpiryMonths",
          expiryUnit: "carryForwardExpiryUnit",
        },
        isDisabled: true,
        showIf: (values) => values.canCarryForward === "yes",
      },
    ],
  },
  {
    title: "Require supporting documents",
    description: "Specify if employees need to submit any documents when requesting this leave.",
    fields: [
      {
        type: "radio",
        name: "requireDocuments",
        label: "Should employees submit any documents with their request?",
        apiKey: "additionalDocumentsRequired",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
    ],
  },
  {
    title: "Future cycle leave filing",
    description: "Allow employees to file leaves for the next anniversary cycle before it starts.",
    fields: [
      {
        type: "radio",
        name: "futureCycleFilingEnabled",
        label: "Can employees file leaves for the next cycle?",
        apiKey: "futureCycleFilingEnabled",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
      },
      {
        type: "input-with-suffix",
        name: "futureCycleWindowMonths",
        label: "How many months of the next cycle can they file for?",
        apiKey: "futureCycleWindowMonths",
        suffix: "month(s)",
        isDisabled: true,
        showIf: (values) => values.futureCycleFilingEnabled === "yes",
      },
      {
        type: "select",
        name: "futureCycleDeductionSource",
        label: "Where should the leave days be deducted from?",
        apiKey: "futureCycleDeductionSource",
        options: [
          { value: "next_cycle", label: "Next cycle balance" },
          { value: "current_cycle", label: "Current cycle balance" },
        ],
        isDisabled: true,
        showIf: (values) => values.futureCycleFilingEnabled === "yes",
      },
      {
        type: "radio",
        name: "futureCycleBlockedOnZeroBalance",
        label: "Is filing blocked when current balance is zero?",
        apiKey: "futureCycleBlockedOnZeroBalance",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
        showIf: (values) => values.futureCycleFilingEnabled === "yes",
      },
      {
        type: "input-with-suffix",
        name: "futureCycleMaxDaysCap",
        label: "Maximum days cap for next cycle filing",
        apiKey: "futureCycleMaxDaysCap",
        suffix: "day(s)",
        isDisabled: true,
        showIf: (values) => values.futureCycleFilingEnabled === "yes",
      },
      {
        type: "radio",
        name: "futureCycleEdgeAdminOnly",
        label: "Can only Edge admins file these leaves?",
        apiKey: "futureCycleEdgeAdminOnly",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
        showIf: (values) => values.futureCycleFilingEnabled === "yes",
      },
      {
        type: "radio",
        name: "futureCycleAdminCancelOnly",
        label: "Can only Edge admins cancel these leaves after cycle refresh?",
        apiKey: "futureCycleAdminCancelOnly",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        isDisabled: true,
        showIf: (values) => values.futureCycleFilingEnabled === "yes",
      },
    ],
  },
];
